import templateStr from 'text!./templates/facebook.html';

var fn = function fn(FacebookService) {
    return {
        restrict: 'E',
        template: templateStr,
        link: function link($scope, $element) {
            FacebookService.getClient().then(function (fbClient) {
                fbClient.XFBML.parse($element[0]); // Updates the dynamically inserted fb-related markup
            });
        }
    };
};
fn.$inject = ['FacebookService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/mediasidebar/directives/FacebookDirective.js
// module id = 1993
// module chunks = 0